import { FormEvent } from 'react';
import { Button, ButtonGroup, Col, FormControl, Row, Well } from 'react-bootstrap';
import { ICenterBase, ICenterFiveStarSurveyType } from '@nkr/models/index';

interface IProps {
    startDate: string,
    endDate: string,
    centerId: number,
    surveyType: ICenterFiveStarSurveyType,
    isAdmin: boolean,
    centerList: ICenterBase[],
    onFilterChange: (startDate: string, endDate: string, centerId: number, surveyType: ICenterFiveStarSurveyType) => void,
    onFilter: () => void
}

const NetworkFiveStarSurveyFilter = (props: IProps) => {
    const handleStartDateChange = (e: FormEvent<FormControl & HTMLInputElement>) => {
        let startDate = e.currentTarget.value;

        props.onFilterChange(startDate, props.endDate, props.centerId, props.surveyType);
    };

    const handleEndDateChange = (e: FormEvent<FormControl & HTMLInputElement>) => {
        let endDate = e.currentTarget.value;

        props.onFilterChange(props.startDate, endDate, props.centerId, props.surveyType);
    };

    const handleStatusChange = (e: FormEvent<HTMLInputElement>) => {
        let surveyType = props.surveyType;

        surveyType[e.currentTarget.value.toLowerCase()] = !props.surveyType[e.currentTarget.value.toLowerCase()];

        props.onFilterChange(props.startDate, props.endDate, props.centerId, surveyType);
    };

    const handleCenterChange = (e: React.ChangeEvent<FormControl & HTMLSelectElement>) => {
        let centerId = parseInt(e.currentTarget.value);

        props.onFilterChange(props.startDate, props.endDate, centerId, props.surveyType);
    }

    return (
        <Well>
            <Row>
                <Col xs={12} lg={3}>
                    <div>&nbsp;</div>
                    <ButtonGroup>
                        <input type='button' className={"btn " + (props.surveyType.dash ? 'btn-primary active' : 'btn-default')} name='statuses' value='DASH' onClick={handleStatusChange} />
                        <input type='button' className={"btn " + (props.surveyType.dcn ? 'btn-primary active' : 'btn-default')} name='statuses' value='DCN' onClick={handleStatusChange} />
                        <input type='button' className={"btn " + (props.surveyType.nkr ? 'btn-primary active' : 'btn-default')} name='statuses' value='NKR' onClick={handleStatusChange} />
                    </ButtonGroup>
                </Col>

                <Col xs={12} lg={2}>
                    <div style={{ marginRight: 5 }}>Start Date:&nbsp;</div>
                    <FormControl
                        type='date'
                        name='startDate'
                        value={props.startDate}
                        onChange={handleStartDateChange}
                    />
                </Col>

                <Col xs={12} lg={2}>
                    <div style={{ marginRight: 5 }}>End Date:</div>
                    <FormControl
                        type='date'
                        name='endDate'
                        value={props.endDate}
                        onChange={handleEndDateChange}
                    />
                </Col>

                {props.isAdmin && (
                    <Col xs={12} lg={2}>
                        <div style={{ marginRight: 5 }}>Center:</div>
                        <FormControl
                            componentClass="select"
                            style={{ width: "initial" }}
                            value={props.centerId}
                            onChange={handleCenterChange}
                        >
                            <option value={0}>- ALL CENTERS -</option>
                            {props.centerList.map((center, index) =>
                                <option key={index} value={center.id}>{center.alias}</option>
                            )}
                        </FormControl>
                    </Col>
                )}

                <Col xs={12} lg={3}>
                    <div>&nbsp;</div>
                    <Button bsStyle='primary' style={{ width: '100%' }} onClick={props.onFilter}>Filter</Button>
                </Col>
            </Row>

            {/* {props.isAdmin && (
                <Row>
                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginLeft: '20px' }} >
                        <div style={{ marginRight: 5 }}>Center:</div>
                        <FormControl
                            componentClass="select"
                            style={{ width: "initial" }}
                            value={props.centerId}
                            onChange={handleCenterChange}
                        >
                            <option value={0}>- ALL CENTERS -</option>
                            {props.centerList.map((center, index) =>
                                <option key={index} value={center.id}>{center.alias}</option>
                            )}
                        </FormControl>
                    </div>

                </Row>
            )} */}
        </Well>
    );
}

export default NetworkFiveStarSurveyFilter;

